import { DefaultButton, Fabric } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { showGettingStarted } from '../../actions';
import './Welcome.css';

class Welcome extends React.Component {
  static propTypes = {
    showGettingStarted: PropTypes.func.isRequired
  };

  render() {
    return (
      <Fabric>
        <div className="container">
          <h1>Welcome</h1>
          <p>
            Brandfolder enables you and your team to effortlessly increase brand consistency and
            engagement in a uniquely visual fashion.
          </p>
          <p>
            This add-in enables you to quickly and easily insert images from Brandfolder into your
            PowerPoint presentations and Word documents.
          </p>
          <div className="ms-Grid actions">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm2">&nbsp;</div>
              <div className="ms-Grid-col ms-sm8">
                <DefaultButton primary={true} onClick={() => this.props.showGettingStarted()}>
                  Get Started
                </DefaultButton>
              </div>
              <div className="ms-Grid-col ms-sm2">&nbsp;</div>
            </div>
          </div>
        </div>
      </Fabric>
    );
  }
}

// const mapStateToProps = state => ({
//   page: state.page.
// });

const mapDispatchToProps = dispatch => ({
  showGettingStarted: () => dispatch(showGettingStarted())
});

export default connect(
  null,
  mapDispatchToProps
)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/Welcome/Welcome.js